import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const adjustVisitDates = async ({ vppId, open_date, close_date }) => {
  const token = localStorage.getItem("token");

  const response = await axios.patch(
    `${__API_URL__}/api/photos/adjust_visit_dates/${vppId}/`,
    { open_date, close_date },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useAdjustVisitDatesMutation = ({ visitId, patientId } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: adjustVisitDates,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["visit_schedule", visitId, patientId] });
      queryClient.invalidateQueries({ queryKey: ["visit_overview"] });
    },
  });
};

export default useAdjustVisitDatesMutation;
